(function () {
  if (window.__requireVariantSelectionInit) return;
  window.__requireVariantSelectionInit = true;

  var ATTR = 'data-user-pristine';
  var PICKERS = 'variant-radios, variant-selects, variant-quick-view-radios, variant-quick-view-selects';
  var GROUPS = '.productView variant-radios .product-form__input, .productView variant-selects .product-form__input, .productView variant-quick-view-radios .product-form__input, .productView variant-quick-view-selects .product-form__input';

  function errorText() {
    return (window.variantStrings && window.variantStrings.selectAllOptions) || 'Bitte wählen Sie für jede Variante eine Option aus.';
  }

  function optionGroups(scope) {
    return (scope || document).querySelectorAll(GROUPS);
  }

  function markPristine(scope) {
    optionGroups(scope).forEach(function (group) {
      if (!group.hasAttribute(ATTR)) group.setAttribute(ATTR, 'true');
    });
  }

  function pristineGroups(view) {
    return view && view.querySelectorAll ? view.querySelectorAll('.product-form__input[' + ATTR + '="true"]') : [];
  }

  function getView(el) {
    return el.closest('.productView') || el.closest('.productView-details') || document;
  }

  function setChosen(group) {
    if (!group || !group.hasAttribute(ATTR)) return;
    group.setAttribute(ATTR, 'false');
    var view = getView(group);
    if (pristineGroups(view).length === 0) hideError(view);
  }

  function iconSVG() {
    return '<svg class="variant-required-error__icon" viewBox="-1 -1 26 26" aria-hidden="true" focusable="false">' +
      '<circle class="variant-required-error__icon-bg" cx="12" cy="12" r="12" fill="#E10000"/>' +
      '<circle class="variant-required-error__icon-fg" cx="12" cy="6.6" r="2" fill="#ffffff"/>' +
      '<rect class="variant-required-error__icon-fg" x="10.1" y="9.8" width="3.8" height="8.4" rx="1.2" fill="#ffffff"/></svg>';
  }

  function ensureErrorEl(view) {
    if (!view.querySelector) return null;
    var el = view.querySelector('.variant-required-error');
    if (el) return el;

    var variants = view.querySelector('.productView-variants');
    var host = variants || view.querySelector(PICKERS);
    if (!host) return null;

    el = document.createElement('div');
    el.className = 'variant-required-error';
    el.setAttribute('role', 'alert');
    el.innerHTML = iconSVG() + '<span class="variant-required-error__text">' + errorText() + '</span>';

    if (variants) {
      variants.appendChild(el);
    } else {
      host.insertAdjacentElement('afterend', el);
    }
    return el;
  }

  function showError(view) {
    var el = ensureErrorEl(view);
    if (el) el.classList.add('is-visible');
  }

  function hideError(view) {
    var el = view.querySelector ? view.querySelector('.variant-required-error') : null;
    if (el) el.classList.remove('is-visible');
  }

  function blockIfPristine(e, view) {
    var pristine = pristineGroups(view);
    if (!pristine.length) return false;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    showError(view);
    Array.prototype.forEach.call(pristine, function (group) {
      group.classList.add('variant-required-flash');
      setTimeout(function () { group.classList.remove('variant-required-flash'); }, 1200);
    });
    return true;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.classList && t.classList.contains('product-form__radio')) {
      setChosen(t.closest('.product-form__input'));
    } else if (t.tagName === 'SELECT' && t.closest('variant-selects, variant-quick-view-selects')) {
      setChosen(t.closest('.product-form__input'));
    }
  });

  document.addEventListener('click', function (e) {
    var label = e.target.closest('variant-radios .product-form__label, variant-quick-view-radios .product-form__label');
    if (label) setChosen(label.closest('.product-form__input'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="add"], #product-add-to-cart');
    if (!btn) return;
    if (btn.closest('[data-sticky-add-to-cart], .productView-stickyCart')) return;
    var view = btn.closest('.productView');
    if (!view) return;
    blockIfPristine(e, view);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest) return;
    if (form.closest('[data-sticky-add-to-cart], .productView-stickyCart')) return;
    var view = form.closest('.productView');
    if (!view) return;
    blockIfPristine(e, view);
  }, true);

  function watchInjectedViews() {
    if (!window.MutationObserver) return;
    var queued = false;
    var observer = new MutationObserver(function (records) {
      if (queued) return;
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches(PICKERS) || node.querySelector(PICKERS)) {
            queued = true;
            requestAnimationFrame(function () {
              queued = false;
              markPristine();
            });
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { markPristine(); watchInjectedViews(); });
  } else {
    markPristine();
    watchInjectedViews();
  }
  document.addEventListener('shopify:section:load', function (e) { markPristine(e.target); });
})();
